/**
 * Première vue de la quête du jour : on la sélectionne, même si un clic
 * précédent pointait encore vers une quête plus ancienne.
 */
function resolveQuestJournalSelectedDate({
  selectFirstEntry = false,
  currentDate = null,
  storedDate = null,
  lastSeenActiveDate = null,
  entries = [],
  activeDate = null,
} = {}) {
  const list = Array.isArray(entries) ? entries : [];
  const hasDate = (date) => Boolean(date) && list.some((entry) => entry?.date === date);

  if (hasDate(activeDate) && lastSeenActiveDate !== activeDate) {
    return {
      date: activeDate,
      markActiveSeen: true,
      switchedToUnseenActive: true,
    };
  }

  if (selectFirstEntry) {
    const firstDate = list[0]?.date || null;
    return {
      date: firstDate,
      markActiveSeen: Boolean(activeDate) && firstDate === activeDate,
      switchedToUnseenActive: false,
    };
  }

  const preferred = currentDate || storedDate;
  if (hasDate(preferred)) {
    return {
      date: preferred,
      markActiveSeen: Boolean(activeDate) && preferred === activeDate,
      switchedToUnseenActive: false,
    };
  }

  const fallback = (hasDate(activeDate) && activeDate) || list[0]?.date || null;
  return {
    date: fallback,
    markActiveSeen: Boolean(activeDate) && fallback === activeDate,
    switchedToUnseenActive: false,
  };
}

module.exports = {
  resolveQuestJournalSelectedDate,
};
